import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { LogService } from '../../../services/log.service';
import { TranslationService } from '../../../services/translation.service';
import { ConfigService } from '../../../services/config.service';
import { DataIoService } from '../../../services/data-io.service';
import { ValueChangedConfirmation } from '../../../classes/ValueChangedConfirmation';
import { Helper, MenuNode, BaseSensor, ISensorInterface } from '../../../classes';

@Component({
  selector: 'app-set-phone',
  templateUrl: './set-phone.component.html',
  styleUrls: ['./set-phone.component.scss']
})
export class SetPhoneComponent implements OnInit {
	chars = ['_','0','1','2','3','4','5','6','7','8','9'];
	currentChar : string = '_';
	val:string='';
	interval:any;
	_cursor = true;

	b():string{
		let v = this.val;

		if(v.length >= 4){
			v = v.substr(v.length-3,3);
		}
		if(this.currentChar == '_'){
				return v+(this._cursor?'_':' ');
			
		}else{
			return v+(this._cursor?this.currentChar:'');
		}
	}
	sub:any;
	constructor(
        private menuService: MenuService, 
        private ioService: DataIoService, 
        private logger: LogService, 
        private config: ConfigService, 
        private translator:TranslationService
        ){

	}
	backClicked(){
		if(this.val.length > 0){
			this.val = this.val.substr(0,this.val.length-1);
		}else{
			this.menuService.goto('fachhandwerkerebene');
		}
	}
	upClicked(){
		let idx = this.chars.indexOf(this.currentChar);
		idx++;
		this.currentChar = this.chars[idx%this.chars.length];
	}
	
	downClicked(){
		let idx = this.chars.indexOf(this.currentChar);
		idx--;
		if(idx == -1){
			idx = this.chars.length-1;
		}
		this.currentChar = this.chars[idx%this.chars.length];
	}
	
	confirmClicked(){
		if(this.currentChar == '_'){
			this.ioService.setContactPhone(this.val);
			console.log("Setting contact phone number to: "+this.val);
			this.menuService.goto('fachhandwerkerebene');
		}else{
			this.val += this.currentChar;
			this.currentChar = '_';
		}
	}

	eventHandler(e:string){
		switch(e){
			case 'up':{
				this.upClicked();
				return;
			}
			case 'down':{
				this.downClicked();
				return;
			}
			case 'confirm':{
				this.confirmClicked();
				return;
			}
			case 'back':{
				this.backClicked();
				return;
			}
			default:{

			}

		}
	}
	ngOnInit(){
		this.sub = this.ioService.inputs.events$.subscribe( (e) => { this.eventHandler(e); } ) ;
		this.interval = setInterval( ()=>{
			this._cursor = !this._cursor;
		},600);
		this.val = this.ioService.getContactPhone();
	}
	ngOnDestroy(){
		if(this.interval){
			clearInterval(this.interval);
		}
		if(this.sub){
			this.sub.unsubscribe();
		}
	}
}
